import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useComponentDefaultProps } from '@mantine/styles';
import { closeOnEscape } from '@mantine/utils';
import { useFocusReturn } from '@mantine/hooks';
import { FloatingArrow } from '../../Floating/FloatingArrow/FloatingArrow.js';
import { Transition, FocusTrap, Box, Portal } from '@mantine/core';
import { usePopoverContext } from '../Popover.context.js';
import useStyles from './PopoverDropdown.styles.js';

var _excluded = ["withinPortal", "children"],
  _excluded2 = ["style", "className", "children", "onKeyDownCapture"];
function OptionalPortal(_ref) {
  var _ref$withinPortal = _ref.withinPortal,
    withinPortal = _ref$withinPortal === void 0 ? true : _ref$withinPortal,
    children = _ref.children,
    others = _objectWithoutProperties(_ref, _excluded);
  if (withinPortal) {
    return /*#__PURE__*/React__default.createElement(Portal, _objectSpread2({}, others), children);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
}
var defaultProps = {};
function PopoverDropdown(props) {
  var _ctx$transitionDurati;
  var _useComponentDefaultP = useComponentDefaultProps('PopoverDropdown', defaultProps, props),
    style = _useComponentDefaultP.style,
    className = _useComponentDefaultP.className,
    children = _useComponentDefaultP.children,
    onKeyDownCapture = _useComponentDefaultP.onKeyDownCapture,
    others = _objectWithoutProperties(_useComponentDefaultP, _excluded2);
  var ctx = usePopoverContext();
  var _useStyles = useStyles({
      radius: ctx.radius,
      shadow: ctx.shadow
    }, {
      name: ctx.__staticSelector,
      classNames: ctx.classNames,
      styles: ctx.styles,
      unstyled: ctx.unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var returnFocus = useFocusReturn({
    opened: ctx.opened,
    shouldReturnFocus: ctx.returnFocus
  });
  var accessibleProps = ctx.withRoles ? {
    'aria-labelledby': ctx.getTargetId(),
    id: ctx.getDropdownId(),
    role: 'dialog'
  } : {};
  if (ctx.disabled) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(OptionalPortal, _objectSpread2(_objectSpread2({}, ctx.portalProps), {}, {
    withinPortal: ctx.withinPortal
  }), /*#__PURE__*/React__default.createElement(Transition, {
    mounted: ctx.opened,
    transition: ctx.transition || 'fade',
    duration: (_ctx$transitionDurati = ctx.transitionDuration) !== null && _ctx$transitionDurati !== void 0 ? _ctx$transitionDurati : 150,
    exitDuration: typeof ctx.exitTransitionDuration === 'number' ? ctx.exitTransitionDuration : ctx.transitionDuration
  }, function (transitionStyles) {
    var _ctx$y, _ctx$x;
    return /*#__PURE__*/React__default.createElement(FocusTrap, {
      active: ctx.trapFocus
    }, /*#__PURE__*/React__default.createElement(Box, _objectSpread2(_objectSpread2({}, accessibleProps), {}, {
      ref: ctx.floating,
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, style), transitionStyles), {}, {
        zIndex: ctx.zIndex,
        top: (_ctx$y = ctx.y) !== null && _ctx$y !== void 0 ? _ctx$y : 0,
        left: (_ctx$x = ctx.x) !== null && _ctx$x !== void 0 ? _ctx$x : 0,
        width: ctx.width === 'target' ? undefined : ctx.width
      }),
      className: cx(classes.dropdown, className),
      onKeyDownCapture: closeOnEscape(ctx.onClose, {
        active: ctx.closeOnEscape,
        onTrigger: returnFocus,
        onKeyDown: onKeyDownCapture
      }),
      "data-position": ctx.placement
    }, others), children, /*#__PURE__*/React__default.createElement(FloatingArrow, {
      ref: ctx.arrowRef,
      arrowX: ctx.arrowX,
      arrowY: ctx.arrowY,
      visible: ctx.withArrow,
      position: ctx.placement,
      arrowSize: ctx.arrowSize,
      arrowRadius: ctx.arrowRadius,
      arrowOffset: ctx.arrowOffset,
      arrowPosition: ctx.arrowPosition,
      className: classes.arrow
    })));
  }));
}

export { PopoverDropdown };
//# sourceMappingURL=PopoverDropdown.js.map
